import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M9.558 10.625c0-.92.746-1.667 1.667-1.667h3.75c.92 0 1.666.747 1.666 1.667v3.75c0 .92-.746 1.667-1.666 1.667h-3.75c-.92 0-1.667-.747-1.667-1.667v-3.75Zm-5-2.917L5.6 6.458l1.041 1.25m3.334-1.666L8.933 5l1.042-1.042M15.6 6.042 16.64 5 15.6 3.958M4.558 14.792l1.042 1.25 1.041-1.25m-1.041.625V7.083M16.433 5H9.766" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);